import { useCallback } from 'react';
import { useSiteUrls } from '../api';
import { useBiLogger } from '../../../hooks/useBiLogger/useBiLogger';
import { BI_CONSTANTS } from '../../../hooks/useBiLogger/biConstants';

export function useViewSite() {
  const { data: siteUrl, refetch, isFetching } = useSiteUrls();
  const biLogger = useBiLogger();
  const { ACTION, BUTTON_NAME } = BI_CONSTANTS;

  const viewLiveSite = useCallback(async () => {
    try {
      biLogger.actionClicked({ action: ACTION.VIEW_LIVE_SITE, button_name: BUTTON_NAME.VIEW_LIVE_SITE });

      if (siteUrl) {
        window.open(siteUrl, '_blank');
      } else {
        const { data: result } = await refetch();
        if (result) {
          window.open(result, '_blank');
        }
      }
    } catch (error) {
      console.error('Failed to fetch site URL:', error);
    }
  }, [siteUrl, refetch, biLogger, ACTION.VIEW_LIVE_SITE, BUTTON_NAME.VIEW_LIVE_SITE]);

  return {
    viewLiveSite,
    isViewLoading: isFetching,
  };
}
